import { InfoIconWrapper, InfoIcon, InfoTooltipBox } from "./styles";

export function InfoTooltip({ text, position = "top" }) {
  return (
    <InfoIconWrapper>
      <InfoIcon type="button" aria-label="Ajuda" tabIndex={0}>
        ?
      </InfoIcon>
      <InfoTooltipBox role="tooltip" data-position={position}>
        {text}
      </InfoTooltipBox>
    </InfoIconWrapper>
  );
}